import { render } from "./AddToCollectionButton.vue?vue&type=template&id=caac00ae&scoped=true"
import script from "./AddToCollectionButton.vue?vue&type=script&lang=js"
export * from "./AddToCollectionButton.vue?vue&type=script&lang=js"

import "./AddToCollectionButton.vue?vue&type=style&index=0&id=caac00ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caac00ae"]])

export default __exports__